(() => {
  const config = window.FertileGroundConsentGate;
  if (!config) return;

  const consentValue = 'accepted';
  const gatePath = new URL(config.gatePath, window.location.origin).pathname.replace(/\/$/, '');

  const storageIsAvailable = () => {
    try {
      const probeKey = `${config.storageKey}-probe`;
      window.sessionStorage.setItem(probeKey, '1');
      window.sessionStorage.removeItem(probeKey);
      return true;
    } catch (_) {
      return false;
    }
  };

  const hasConsent = () => {
    try {
      return window.sessionStorage.getItem(config.storageKey) === consentValue;
    } catch (_) {
      return false;
    }
  };

  const recordConsent = () => {
    try {
      window.sessionStorage.setItem(config.storageKey, consentValue);
      return true;
    } catch (_) {
      return false;
    }
  };

  const isGatePage = () => window.location.pathname.replace(/\/$/, '') === gatePath;

  const safeReturnPath = (value) => {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/';

    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '/';
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) {
      return '/';
    }
  };

  const currentPath = () => `${window.location.pathname}${window.location.search}${window.location.hash}`;

  const redirectToGate = () => {
    const url = new URL(config.gatePath, window.location.origin);
    url.searchParams.set('return_to', currentPath());
    window.location.assign(url.pathname + url.search);
  };

  const matchesPurchaseControl = (element) => {
    if (!element || !element.closest) return false;

    return Boolean(element.closest([
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      '.shopify-payment-button button',
      '.shopify-payment-button input[type="submit"]',
      '.pe-product-cart-button button',
      '.pe-product-cart-button input[type="submit"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      '.cart__checkout-button',
      'a[href*="/cart/add"]',
      'a[href*="/checkout"]'
    ].join(',')));
  };

  const isProtectedSubmission = (form, submitter) => {
    if (!form) return false;
    if ((form.getAttribute('action') || '').includes('/cart/add')) return true;
    return Boolean(submitter && matchesPurchaseControl(submitter));
  };

  document.addEventListener('click', (event) => {
    if (hasConsent() || isGatePage()) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!matchesPurchaseControl(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    redirectToGate();
  }, true);

  document.addEventListener('submit', (event) => {
    if (hasConsent() || isGatePage()) return;
    if (!isProtectedSubmission(event.target, event.submitter)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    redirectToGate();
  }, true);

  const page = document.querySelector('[data-fg-consent-page]');
  if (!page) return;

  const checkbox = page.querySelector('[data-fg-consent-checkbox]');
  const continueButton = page.querySelector('[data-fg-consent-continue]');
  const status = page.querySelector('[data-fg-consent-status]');
  if (!checkbox || !continueButton) return;

  const showStorageError = () => {
    checkbox.disabled = true;
    continueButton.disabled = true;
    if (!status) return;

    status.hidden = false;
    status.textContent = 'We could not save your acknowledgement in this browser. Please enable browser storage and try again.';
  };

  if (!storageIsAvailable()) {
    showStorageError();
    return;
  }

  const updateButton = () => {
    continueButton.disabled = !checkbox.checked;
  };

  checkbox.addEventListener('change', updateButton);
  updateButton();

  continueButton.addEventListener('click', () => {
    if (!checkbox.checked) return;
    if (!recordConsent()) {
      showStorageError();
      return;
    }

    const returnTo = safeReturnPath(new URLSearchParams(window.location.search).get('return_to'));
    if (page.dataset.customerSignedIn === 'true') {
      window.location.assign(returnTo);
      return;
    }

    const loginUrl = new URL(config.storefrontLoginUrl, window.location.origin);
    loginUrl.searchParams.set('return_to', returnTo);
    window.location.assign(loginUrl.toString());
  });
})();
